import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import App from './App'
import Error from './404'
import React from 'react'
import RegisterSale from './pages/RegisterSale'
import ViewStorage from './pages/ViewStorage'
import SaleSupport from './pages/SaleSupport'
import PendingSale from './pages/PendingSale'
import { contentPath, modules } from './config/const'
import ViewPos from './pages/ViewPos'
import ViewCashSession from './pages/ViewCashSession'
import ViewCashRegister from './pages/ViewCashRegister'
import Forbidden from './pages/Forbidden'
import ViewCustomer from './pages/ViewCustomer'
import BillDetail from './pages/BillDetail'
import CreditNoteList from './pages/CreditNoteList'
import DebitNoteList from './pages/DebitNoteList'
import RegisterNote from './pages/RegisterNote'
import SalesReports from './pages/SalesReports'

function Routes(){
  return (
    
    <Router>
      <Switch>
        <Route exact path="/" component={App}/> 
        <Route exact path="/sorry" component={Forbidden}/> 
        <Route exact path={contentPath[modules.RegisterSale]} component={RegisterSale}/>  
        <Route exact path={contentPath[modules.StorageItemList]} component={ViewStorage}/> 
        <Route exact path={contentPath[modules.BillList]} component={SaleSupport}/> 
        <Route exact path={contentPath[modules.PendingSalesList]} component={PendingSale}/> 
        <Route exact path={contentPath[modules.POSList]} component={ViewPos}/> 
        <Route exact path={contentPath[modules.CashSessionList]} component={ViewCashSession}/> 
        <Route exact path={contentPath[modules.CashRegisterList]} component={ViewCashRegister}/> 
        <Route exact path={contentPath[modules.ContactList]} component={ViewCustomer}/> 
        <Route exact path={contentPath[modules.BillDetail]} component={BillDetail}/> 
        <Route exact path={contentPath[modules.CreditNoteList]} component={CreditNoteList}/> 
        <Route exact path={contentPath[modules.DebitNoteList]} component={DebitNoteList}/> 
        <Route exact path={contentPath[modules.CreateNote]} component={RegisterNote}/> 
        <Route exact path={contentPath[modules.SalesReports]} component={SalesReports}/> 
        <Route component={Error} />
      </Switch>
    </Router>
  )
}

export default Routes